var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatGptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0F1214"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5507 12.9896V8.57141L21.3716 15.4401L12.5507 12.9896ZM11.8226 8.57141V12.9896L3 15.4401L11.8226 8.57141Z",
    fill: "#FF8900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGptIcon);
export default __webpack_public_path__ + "static/media/chatGptIcon.26d7ec6a2d784b9509dd00ac17823d22.svg";
export { ForwardRef as ReactComponent };